import instance from "@/services/api";

export const showroomsAPI = {
  async getShowrooms() {
    return await instance()
      .get("/handbook/show_room/read/",)
      .then((res) => res?.data);
  },

  async getShowroomPhotos(front_show_room_id) {
    return await instance()
      .get(`handbook/show_room/${front_show_room_id}/photo_read/`,)
      .then((res) => res?.data);
  },
  async updShowroomPhoto(body) {
    return await instance()
      .post(`handbook/show_room/photo_upd/`, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },
  async deleteShowroomPhoto(front_show_room_photo_id) {
    return await instance()
      .delete(`/handbook/show_room/${front_show_room_photo_id}/delete/`)
      .then((res) => res?.data);
  },
}